/**
 * Tile Units Lookup
 *
 * Maps metric titles to their display units
 */
export const tileUnits: { [key: string]: string } = {
  // Pitch data
  Efficiency: "Percent",
  Extension: "Feet",
  "Horz Apr Angle": "Degrees",
  "Horz Break": "Inches",
  "Horz Rel Angle": "Degrees",
  "I. Vert Break": "Inches",
  "Plate Ht.": "Feet",
  "Plate Side": "Feet",
  plateEpochSeconds: "Seconds",
  "Rel Height": "Feet",
  "Rel Side": "Feet",
  "Spin Axis": "Degrees",
  "Spin Rate": "RPM",
  Tilt: "O Clock",
  Velocity: "MPH",
  "Vert Apr Angle": "Degrees",
  "Vert Break": "Inches",
  yt_EffectiveSpinRPM: "RPM",
  FSRI: "Percent",
  yt_GyroSpinRPM: "RPM",
  yt_HorzApprAngleDegrees: "Degrees",
  yt_HorzBreakInches: "Inches",
  yt_HorzRelAngleDegrees: "Degrees",
  yt_InducedVertBreakInches: "Inches",
  yt_PlateLocHeightFeet: "Feet",
  yt_RelSideFeet: "Feet",
  yt_ZoneSpeedMPH: "MPH",
  yt_ZoneTimeSeconds: "Seconds",
  "Zone Time": "Seconds",
  "Zone Velo": "MPH",

  // Hit data
  "Bat'd Spin Rate": "RPM",
  Bearing: "Degrees",
  Direction: "Degrees",
  Distance: "Feet",
  "Exit Velo": "MPH",
  exitEpochSeconds: "Seconds",
  "Hang Time": "Seconds",
  "Launch Angle": "Degrees",
  yt_EffectiveBattingSpeedMPH: "MPH",
  yt_GroundLocationXFeet: "Feet",
  yt_GroundLocationYFeet: "Feet",
  yt_HitBreakTSeconds: "Seconds",
  yt_HitBreakXFeet: "Inches",
  yt_HitBreakYFeet: "Feet",
  yt_HitLocationXFeet: "Feet",
  yt_HitLocationYFeet: "Feet",
  yt_HitLocationZFeet: "Feet",
  yt_HitSpinComponentX: "",
  yt_HitSpinComponentY: "",
  yt_HitSpinComponentZ: "",
  yt_HitVelocityXMPH: "MPH",
  yt_HitVelocityYMPH: "MPH",
  yt_HitVelocityZMPH: "MPH",
};
